// Backdrop.tsx
import React from 'react';
import 'assets/scss/backdrop.scss'

interface BackdropProps {
    show: boolean;
    onClick: () => void;
    zIndex?: number;
}

export const Backdrop = ({ show, onClick, zIndex = 100 }: BackdropProps) => {
    if (!show) return null;

    return (
        <div
            className="backdrop"
            onClick={onClick}
            style={{ zIndex }}
        />
    );
};